import * as React from "react";
import type { SVGProps } from "react";
const SvgTrashCan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1ZM15 11a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0v-6Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.586 2.586A2 2 0 0 1 9 2h6a2 2 0 0 1 2 2v2h4a1 1 0 1 1 0 2h-1.08L19 19.046A3 3 0 0 1 16 22H8a3 3 0 0 1-3-2.954L4.08 8H3a1 1 0 0 1 0-2h4V4a2 2 0 0 1 .586-1.414ZM9 6h6V4H9v2ZM6.087 8l.91 10.917A.995.995 0 0 1 7 19a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1 1 1 0 0 1 .003-.083L17.913 8H6.087Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTrashCan;
